<div id="root"><component :is="layout" v-if="layout"><router-view></router-view></component></div>